import { FC, PropsWithChildren } from "react";



const cardStyle = {
  paddingBottom: "6.5px",
  width: "fit-content",
  height: "fit-content",
  paddingRight: "1px",
  justifySelf: "center",
};

export const ProjectCard: FC<PropsWithChildren> = (props) => {
  const { children, ...rest } = props;
  return (
    <div {...rest} style={cardStyle}>
      {children}
    </div>
  );
};
